import { Modal, Table, Badge } from "react-bootstrap";
import { format } from "date-fns";
import currency from "currency.js";
import { useCurrencies } from "../../../utils/hooks";

export default function PromoIncentiveEarnLogLogModal({
  show,
  onHide,
  payout,
}) {
  const earns = payout?.promo_incentive_earn || [];
  const incentiveName = payout?.promo_incentive?.Name;
  const { prevailingCurrencySymbol } = useCurrencies();
  const money = (value) =>
    currency(value || 0, {
      symbol: prevailingCurrencySymbol,
      precision: 2,
    }).format();

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      scrollable
      animation={false}
      autoFocus={false}
      enforceFocus={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title as={"h6"}>
          Promo Incentive Claim Earned
          {incentiveName ? ` - ${incentiveName}` : ""}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex mb-3 row align-items-center">
          <p className="col-3">
            <b>Payout #:</b> {payout?.id ?? "_"}
          </p>
          <p className="col-3">
            <b>Status:</b>{" "}
            <Badge
              style={{ textTransform: "capitalize" }}
              bg={
                ["met", "partially paid"].includes(payout?.status)
                  ? "success"
                  : "warning"
              }
            >
              {payout?.status || "_"}
            </Badge>
          </p>
          <p className="col-3">
            <b>Buy:</b> {payout?.thresholdSnapshot ?? "_"} (
            {payout?.thresholdBySnapshot})
          </p>
          <p className="col-3">
            <b>Get:</b> {payout?.claimValueSnapshot ?? "_"} (
            {payout?.claimBySnapshot})
          </p>
        </div>

        <hr />

        <div className="table-responsive">
          <Table striped className="align-middle mb-0">
            <thead>
              <tr>
                <th>Invoice No</th>
                <th>Batch Barcode</th>
                <th>Batch Date</th>
                <th>Line Count</th>
                <th>Amount</th>
                <th>Eligible</th>
                <th>Reversed</th>
              </tr>
            </thead>
            <tbody>
              {earns.length ? (
                earns.map((log) => (
                  <tr
                    key={log.id}
                    style={log.reversed ? { backgroundColor: "#f8d7da" } : {}}
                  >
                    <td>{log.invoiceNo || "—"}</td>
                    <td>{log.stockBatchBarCode || "—"}</td>
                    <td>
                      {log.batchDate
                        ? format(new Date(log.batchDate), "MMM dd, yyyy")
                        : "—"}
                    </td>
                    <td>{log.lineCount ?? "—"}</td>
                    <td>{money(log.amount)}</td>

                    <td>
                      <Badge bg={log.eligible ? "success" : "danger"}>
                        {log.eligible ? "Yes" : "No"}
                      </Badge>
                    </td>
                    <td>
                      {log.reversed ? (
                        <Badge bg="danger">
                          Reversed
                          {log.reversedAt
                            ? ` - ${format(
                                new Date(log.reversedAt),
                                "MMM dd, yyyy",
                              )}`
                            : ""}
                        </Badge>
                      ) : (
                        "—"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={9} className="text-center py-4">
                    No earn logs recorded for this payout.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
}
